import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  TextField,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Transition from "../../stateless/Transition";
import { DistributionService } from "../../../services/distribution.service";
import { AuthService } from "../../../services/auth.service";
import StatusDistributionSelect from "../../shared/selects/StatusDistributionSelect";
import { ValidatorForm } from "react-material-ui-form-validator";
import styles from "../../../styles/global-styles";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "auto", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  helperText: {
    color: "red",
  },
  rightButton: styles.buttonRightHeader,
}));

const AcceptDistributionProduct = ({
  onClose,
  open,
  idsSelected,
  distributionAccepted,
}) => {
  const classes = useStyles();
  const { name, siteId } = AuthService.currentUserValue;

  const [queryParams, setqueryParams] = useState({});
  const [showInput, setShowInput] = useState(false);
  const [hasError, setHasError] = React.useState({});

  const handleClose = () => onClose();

  useEffect(() => {
    if (
      queryParams?.statusDistributionId === 3 ||
      queryParams?.statusDistributionId === 5
    ) {
      setShowInput(true);
    } else setShowInput(false);
  }, [queryParams]);

  const handleAcceptDistribution = async () => {
    // console.log("idsSelected", idsSelected);
    if (queryParams.statusDistributionId === 3 && !queryParams.comments) {
      setHasError({ ...hasError, showError: true, option: 1 });
      return;
    } else {
      setHasError({ ...hasError, showError: false, option: null });
      /**
       * statusDistributionId 2 === Aceptada
       * statusDistributionId 3 === Rechazada
       * statusDistributionId 5 === Devuelta
       * */
      console.log("queryParams", queryParams);
      const body = {
        idsSelected,
        status: queryParams?.statusDistributionId,
        inDistribution:
          queryParams?.statusDistributionId === 3 ||
          queryParams?.statusDistributionId === 5
            ? true
            : false,
        comments: queryParams.comments || null,
        siteId,
      };
      try {
        const {
          data,
          status,
        } = await DistributionService.updateStatusAndInDistributionProduct(
          body
        );
        if (status === 201) {
          distributionAccepted({
            success: true,
            message:
              "Se actualizó el estatus de la(s) distribución(es) de manera exitosa",
          });
        } else
          distributionAccepted({
            success: false,
            message: "Error al acualizar el estatus de la(s) distribución(es)",
          });
      } catch (error) {
        console.log("error", error);
        distributionAccepted({ success: false, message: error.msgs });
      }
    }
  };

  const handleImeiInput = ({ target: { name, value } }) => {
    if (
      queryParams.comments !== undefined &&
      queryParams.comments.length < 10
    ) {
      setHasError({ ...hasError, showError: true, option: 2 });
    } else if (queryParams.comments?.length > 10) {
      setHasError({ ...hasError, showError: false, option: null });
    }
    setqueryParams({ ...queryParams, [name]: value });
  };

  const handleOptionSelected = (key, value) =>
    setqueryParams({ ...queryParams, [key]: value });

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="simple-dialog-title" style={{ textAlign: "center" }}>
        Actualizar{" "}
        {idsSelected.length === 1 ? "distribución" : "distribuciones"}
      </DialogTitle>
      <DialogContent>
        <p style={{ fontWeight: 600, margin: 30 }}>
          Actualmente en sesión: {name}
        </p>
        <ValidatorForm
          noValidate
          onKeyPress={(event) => {
            if (event.which === 13 /* Enter */) {
              event.preventDefault();
            }
          }}
          method="POST"
          onSubmit={(e) => handleAcceptDistribution(e)}
          onError={() => {}}
        >
          <StatusDistributionSelect
            confirmDistribution
            status={handleOptionSelected}
          />
          {showInput && (
            <TextField
              style={{ margin: 30 }}
              id="outlined-secondary"
              placeholder="Agregar comentarios"
              multiline
              rowsMax={4}
              name="comments"
              variant="outlined"
              onChange={(e) => handleImeiInput(e)}
              value={queryParams.comments || ""}
              color="primary"
              helperText={
                hasError.showError && hasError.option === 1
                  ? "El campo no puede estar vacio"
                  : hasError.showError && hasError.option === 2
                  ? "Los comentarios deben de tener un tamaño mayor a 10"
                  : ""
              }
              FormHelperTextProps={{
                className: classes.helperText,
              }}
            />
          )}
          <Grid
            style={{ marginTop: 40 }}
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item>
              <Button
                color="primary"
                style={{ marginRight: 50, width: 150 }}
                onClick={() => handleClose()}
              >
                Cancelar
              </Button>
            </Grid>
            <Grid item>
              <Button
                className={classes.rightButton}
                variant="contained"
                disabled={!queryParams.statusDistributionId}
                color="primary"
                type="submit"
                endIcon={<CheckCircleIcon color="secondary" />}
              >
                Actualizar
              </Button>
            </Grid>
          </Grid>
        </ValidatorForm>
      </DialogContent>
    </Dialog>
  );
};

export default AcceptDistributionProduct;
